export default {
  name: [],
  description: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  nameDefault: [],
  descriptionDefault: [],
}
